import { fetchSuggestions as fetchSuggestionsAction } from '../../../../actions/suggestions/suggestions'
import { formatSuggestionsForDisplay } from '../format-suggestion'

/**
 * Önerileri getirir
 * @param {Object} params - Filtreleme parametreleri (assetId vb.)
 * @returns {Promise<Object>} Öneri listesi
 */
export const fetchSuggestions = async (params = {}) => {
  try {
    // API çağrısını assetId parametresi ile yap
    const response = await fetchSuggestionsAction(params)

    // Cevabı formatla ve döndür
    if (response.code === 200 && response.data) {
      // Backend artık tüm önerileri gönderiyor, pagination olmadan
      const formattedSuggestions = formatSuggestionsForDisplay(response.data.data || [])
      return {
        success: true,
        data: formattedSuggestions,
      }
    }

    return {
      success: false,
      message: response.message || 'Bir hata oluştu',
      data: [],
    }
  } catch (error) {
    console.error('Error fetching suggestions:', error)
    return {
      success: false,
      message: error.message || 'Öneriler yüklenirken bir hata oluştu',
      data: [],
    }
  }
}